import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import { UserProfile } from '@teetsh/app/src/types/user';
import {
  deserializeNotationSystem,
  serializeUser,
} from '@teetsh/app/src/queries/user/serializer';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useUpdateUser() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['userSettings']);

  const { mutateAsync } = useMutation({
    mutationFn: (user: UserProfile) =>
      request('/user/settings', {
        method: 'PATCH',
        body: serializeUser(user),
      }),
    onMutate: user => {
      queryClient.setQueryData<UserProfile>([USER_KEY], {
        ...user,
        // Si on update le système de notation ça renvoi seulement les notations du user, pas celle par défaut
        // Or c'est le deserialize qui ajoute les systèmes par default
        // Du coup on règle le bordel ici
        // TODO: faire un CRUD à part pour les notations systems
        notationSystems: deserializeNotationSystem(
          Object.values(user.notationSystems),
        ),
      });
    },
    onError: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
      notifyError({
        title: t('userSettings:messages.updateSettingsError'),
      });
    },
  });
  return mutateAsync;
}
